import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@metarouter-private/mr-mui';
import { useTestPlaybookDrawerContext } from 'app/playbook-editor/transform-drawer/TestPlaybookDrawerContextProvider';
import DRAWER_MODES from 'app/playbook-editor/transform-drawer/TestPlaybookDrawerContextProvider/DRAWER_MODES';

export default function ModeSwitch() {
  const { mode, onChangeMode } = useTestPlaybookDrawerContext();

  const handleChange = (event, newMode) => {
    // ToggleButtonGroup emits null when the active button is clicked again.
    if (newMode !== null) {
      onChangeMode(newMode);
    }
  };

  return (
    <ToggleButtonGroup value={mode} exclusive onChange={handleChange} size="small" color="primary">
      <ToggleButton value={DRAWER_MODES.BASIC}>Basic</ToggleButton>
      <ToggleButton value={DRAWER_MODES.ADVANCED}>Advanced</ToggleButton>
    </ToggleButtonGroup>
  );
}
